"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExperimentTreatment = exports.TreatmentValue = void 0;
const react_1 = require("react");
var TreatmentValue;
(function (TreatmentValue) {
    TreatmentValue["Control"] = "control";
    TreatmentValue["Treatment0"] = "treatment_0";
    TreatmentValue["Treatment1"] = "treatment_1";
    TreatmentValue["Treatment2"] = "treatment_2";
    TreatmentValue["Treatment3"] = "treatment_3";
    TreatmentValue["Treatment4"] = "treatment_4";
})(TreatmentValue = exports.TreatmentValue || (exports.TreatmentValue = {}));
function useExperimentTreatment(experimentId, configs = []) {
    const config = (0, react_1.useMemo)(() => configs.find((config) => config.configId === experimentId), [configs, experimentId]);
    if (configs.length < 1) {
        return TreatmentValue.Control;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (!config || !config.value || !config.value.stringValue) {
        return TreatmentValue.Control;
    }
    return config.value.stringValue;
}
exports.useExperimentTreatment = useExperimentTreatment;
//# sourceMappingURL=useExperiment.js.map